import React, { useEffect, useState } from "react";
import { RiImageAddFill } from "react-icons/ri";
import { SiGooglesheets } from "react-icons/si";
import * as XLSX from "xlsx"; // Librería para procesar Excel
import BulkUpload from "../BulkUpload";
import {
  getAllSubClasses,
  getImages,
  handleBulkCreate,
  uploadProductImage,
} from "../../../services/products";
import {
  getProductClasses,
  getProductSubClasses,
} from "../../../services/productClass";
import Notification from "../../ui-elements/Notification";
import Switch from "../../Switch";
import Select from "../../Select";
import { IS_LOCAL_ENV } from "../../../App";

const SelectLoad = ({ handleClose, bulkLoadToParent }) => {
  const [mainImgFiles, setMainImgFiles] = useState([]); // Almacena las imágenes
  const [otherImgFiles, setOtherImgFiles] = useState([]); // Almacena las imágenes
  const [uploading, setUploading] = useState(false);
  const [excelData, setExcelData] = useState(null); // Almacena los datos del Excel
  const [loading, setLoading] = useState(true);
  const [classesList, setClassesList] = useState([]);
  const [subClassesList, setSubClassesList] = useState([]);
  const [mainImagesList, setMainImagesList] = useState([]);
  const [otherImagesList, setOtherImagesList] = useState([]);
  const [option, setOption] = useState("products");

  const options = [
    { text: "Productos", value: "products" },
    { text: "Imágenes", value: "images" },
  ];

  // Manejo de carga de imágenes principales
  const handleMainImgChange = (e) => {
    const files = Array.from(e.target.files);
    setMainImgFiles(files); // Actualiza las imágenes principales
    setOtherImgFiles([]); // Vacía otras imágenes
  };

  // Manejo de carga de otras imágenes
  const handleOtherImgChange = (e) => {
    const files = Array.from(e.target.files);
    setOtherImgFiles(files); // Actualiza otras imágenes
    setMainImgFiles([]); // Vacía imágenes principales
  };

  const [selectedSubClass, setSelectedSubClass] = useState(null);

  const [subClassesOptions, setSubClassesOptions] = useState([]);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const { docs } = await getProductClasses();
        setClassesList(docs);
      } catch (err) {
        Notification({
          title: "Error",
          text: "Algo salió mal al cargar las clases...",
          type: "Error",
        });
      }
    };

    const fetchSubClasses = async () => {
      try {
        const { docs } = await getAllSubClasses();
        setSubClassesList(docs);
        let arr = docs.map((doc) => {
          return { text: doc.name, value: doc.id };
        });
        setSubClassesOptions(arr);
      } catch (err) {
        Notification({
          title: "Error",
          text: "Algo salió mal al cargar las subclases...",
          type: "Error",
        });
      }
    };

    const fetchImages = async () => {
      try {
        const { docs } = await getImages();
        IS_LOCAL_ENV && console.log("iMÁGENES: ", docs);
        setMainImagesList(docs.filter((doc) => doc.isMainImage));
        setOtherImagesList(docs.filter((doc) => !doc.isMainImage));
      } catch (err) {
        Notification({
          title: "Error",
          text: "Algo salió mal al cargar las imágenes...",
          type: "Error",
        });
      }
    };

    fetchClasses();
    fetchSubClasses();
    fetchImages();
    setLoading(false);
  }, []);

  const handleLoadMainImages = async () => {
    if (!selectedSubClass || mainImgFiles.length === 0) {
      return Notification({
        title: "Error",
        text: "Por favor selecciona una subclase y carga imágenes principales.",
        type: "Error",
      });
    }

    try {
      setUploading(true);
      let uploadedImages = [];
      for (const file of mainImgFiles) {
        const response = await uploadProductImage({
          file,
          isMainImage: true,
          subClass: selectedSubClass,
        });
        uploadedImages.push(response);
      }
      setMainImagesList((prev) => [...prev, ...uploadedImages]);
      setUploading(false);
      Notification({
        title: "Éxito",
        text: "Imágenes principales cargadas correctamente.",
        type: "Success",
      });
      handleClose();
    } catch (err) {
      setUploading(false);
      Notification({
        title: "Error",
        text: "Ocurrió un error al cargar las imágenes principales.",
        type: "Error",
      });
      IS_LOCAL_ENV && console.error(err);
    }
  };

  const handleLoadOtherImages = async () => {
    if (!selectedSubClass || otherImgFiles.length === 0) {
      return Notification({
        title: "Error",
        text: "Por favor selecciona una subclase y carga otras imágenes.",
        type: "Error",
      });
    }

    try {
      setUploading(true);
      let uploadedImages = [];
      for (const file of otherImgFiles) {
        const response = await uploadProductImage({
          file,
          isMainImage: false,
          subClass: selectedSubClass,
        });
        uploadedImages.push(response);
      }
      setOtherImagesList((prev) => [...prev, ...uploadedImages]);
      setUploading(false);
      Notification({
        title: "Éxito",
        text: "Otras imágenes cargadas correctamente.",
        type: "Success",
      });
      handleClose();
    } catch (err) {
      setUploading(false);
      Notification({
        title: "Error",
        text: "Ocurrió un error al cargar otras imágenes.",
        type: "Error",
      });
      IS_LOCAL_ENV && console.error(err);
    }
  };
  if (!loading)
    return (
      <div className="flex flex-col w-full items-center justify-center font-poppins gap-y-4">
        <h3 className="text-xl font-bold">Cargar productos o imágenes</h3>
        <Switch options={options} setOption={(option) => setOption(option)} />
        <div className="flex flex-wrap w-full justify-center gap-4 items-center">
          {option == "products" && (
            <BulkUpload
              classes={classesList}
              subClasses={subClassesList}
              mainImages={mainImagesList}
              otherImages={otherImagesList}
              handleBulkCreate={handleBulkCreate}
              bulkLoadToParent={bulkLoadToParent}
              handleClose={handleClose}
            />
          )}

          {option == "images" && (
            <div className="flex flex-col gap-2 items-center">
              <Select
                options={subClassesOptions}
                setValue={(e) => setSelectedSubClass(e.target.value)} //is an id
                placeholder="Seleccionar Subclase"
                //initialValue
                //customW,|
                //canReset,
                //disabled,
              />

              {/* Botón para cargar imágenes principales */}
              <label className="cursor-pointer bg-dark-green hover:bg-accent-green text-white gap-x-1 text-base font-bold py-2 px-4 rounded-full flex flex-row items-center">
                {"Cargar Imágenes Principales"}
                <RiImageAddFill />
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleMainImgChange}
                  className="hidden"
                />
              </label>
              {/* Mostrar imágenes principales */}
              {mainImgFiles.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {mainImgFiles.map((file, index) => (
                    <img
                      key={index}
                      src={URL.createObjectURL(file)}
                      alt={`main-img-${index}`}
                      className="w-24 h-24 object-cover rounded"
                    />
                  ))}
                </div>
              )}

              {/* Botón para cargar otras imágenes */}
              <label className="cursor-pointer bg-dark-green hover:bg-accent-green text-white gap-x-1 text-base font-bold py-2 px-4 rounded-full flex flex-row items-center">
                {"Cargar Otras Imágenes"}
                <RiImageAddFill />
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleOtherImgChange}
                  className="hidden"
                />
              </label>
              {/* Mostrar otras imágenes */}
              {otherImgFiles.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {otherImgFiles.map((file, index) => (
                    <img
                      key={index}
                      src={URL.createObjectURL(file)}
                      alt={`other-img-${index}`}
                      className="w-24 h-24 object-cover rounded"
                    />
                  ))}
                </div>
              )}

              <button
                className={`${
                  (mainImgFiles.length == 0 && otherImgFiles == 0) ||
                  selectedSubClass == null ||
                  uploading
                    ? "bg-light-gray cursor-not-allowed"
                    : "bg-light-purple-600 hover:bg-dark-purple"
                } text-white rounded-full px-4 py-2 font-bold font-poppins text-nowrap transition-all duration-100 w-fit`}
                onClick={() =>
                  mainImgFiles.length > 0
                    ? handleLoadMainImages()
                    : otherImgFiles.length > 0
                    ? handleLoadOtherImages()
                    : null
                }
                disabled={uploading || selectedSubClass == null}
              >
                Subir
              </button>
            </div>
          )}
        </div>
      </div>
    );
};

export default SelectLoad;
